import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZArray, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XScroll, XText } from "IZOX/_X";
import { QForm } from "IZOX/BLOCKS/Libs";
import Styles from "__SYSDefault/Styles";
import Options from "shared/Options";
import _ from "lodash";
import { MdClose } from "react-icons/md";
import QUICKUI from "shared/QUICKUI";

/**
 * @augments {Component<Props, State>}
 */
class NewClientW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      curStep: 0,
      CIFormValue: {}
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewClientW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toSuccess = () => {
    this.setState({
      curStep: 1
    });
  }

  _onSubmit = async () => {
    let {CIFormValue} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/Agent/NewClient", {
        CIFormValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
  }

  _onCIChange = (formValue) => {
    this.setState({
      CIFormValue: formValue
    });
  }

  _addRow = (name) => {
    let {CIFormValue} = this.state;
    let target = Accessor.Get(CIFormValue, name) ?? [];
    target = [...target, ""];
    Accessor.Set(CIFormValue, name, target);
    this._onCIChange(CIFormValue);
  }

  _removeRow = (name, idx) => {
    let {CIFormValue} = this.state;
    let target = Accessor.Get(CIFormValue, name) ?? [];
    target = ZArray.DeleteIdx(target, idx);
    Accessor.Set(CIFormValue, name, target);
    this._onCIChange(CIFormValue);
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _validateCI = () => {
    let {CIFormValue} = this.state;
    let valid = ZValidate.CheckAllFields(CIFormValue, 
      ["meta.fullName.EN", "meta.gender",
        "meta.HKID", "telNo", "email",
        "meta.primaryAddress.EN"], "required");
    if(!valid) return false;

    valid = ZValidate.CheckAllFields(CIFormValue, ["meta.HKID"], "isHKID");
    if(!valid) return false;

    valid = ZValidate.CheckAllFields(CIFormValue, ["email"], "email");
    if(!valid) return false;

    valid = ZValidate.CheckAllFields(CIFormValue, ["telNo"], "isHKPhone");
    if(!valid) return false;

    valid = ZValidate.CheckLength(CIFormValue, ["meta.fullName.EN"], 3, 50);
    if(!valid) return false;

    let additionalAddresses = Accessor.Get(CIFormValue, "meta.additionalAddress");
    if(additionalAddresses){
      for(let i = 0; i < additionalAddresses?.length; i++){
        let o = additionalAddresses[i];
        valid = ZValidate.CheckAllFields(o, ["EN"], "required");
        if(!valid) return false;
      }
    }
    return true;
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Add new client",
            TC: "增加客戶"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderCustomerInfo(){
    let {CIFormValue, loading} = this.state;
    let {meta = {}} = CIFormValue ?? {};
    let {additionalAddress} = meta ?? {};
    return (
      <VStack fullWidth>
        <XScroll height={600} fullWidth pH={16}>
          <QForm onChange={this._onCIChange} p={8} spacing={16}
            fullWidth value={CIFormValue}>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("meta.fullName.EN",
                {EN: "Full name", TC: "姓名"},
                {starred: true, 
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "meta.fullName.EN"),
                    ["required"])
                })}
              {QUICKUI.WebTextField("meta.fullName.TC",
                {EN: "(Chinese)", TC: "(中文)"},
                {starred: false})}
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("email",
                {EN: "Email", TC: "電郵"},
                {width: "50%", 
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "email"),
                    ["required", "email"])}
              )}
              {QUICKUI.WebDropdown("meta.gender", {
                EN: "Gender",
                TC: "性別"
              }, Options.GetOptionList("Gender"), {
                starred: true,
                width: 329,
                placeholder: {
                  EN: "Gender",
                  TC: "性別"
                },
                errorMessage: 
                  ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "meta.gender"),
                  ["required"])
              })}
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("meta.HKID",
                {EN: "HKID A123456(7)", TC: "香港身份證 A123456(7)"},
                {noSpecialCharacter: true, 
                  starred: true,
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "meta.HKID"),
                    ["required", "isHKID"])
                })}
              {QUICKUI.WithZipCode("telNo", 
                { EN: "Mobile phone", TC: "手機號碼" },
                { 
                  placeholder: {
                    EN: "Enter your mobile phone no.",
                    TC: "輸入你的電話號碼"
                  },
                  starred: true,
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "telNo"),
                    ["required"])
                })}
            </HStack>
            <HStack HAlign="[" spacing={16}>
              {QUICKUI.WebTextField("meta.primaryAddress.EN",
                {EN: "Primary address (English)", TC: "主要地址 (英文)"},
                {width: "50%", starred: true,
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(CIFormValue, "meta.primaryAddress.EN"),
                    ["required"])
                },
              )}
              {QUICKUI.WebTextField("meta.primaryAddress.TC",
                {EN: "(Chinese)", TC: "(中文)"},
                {width: "50%", starred: false},
              )}
            </HStack>           
            <VStack HAlign="[" spacing={24} fullWidth>
              {_.map(additionalAddress, (o, i) => {
                return (
                  <HStack VAlign="_" key={i} HAlign="[" spacing={24}>
                    {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                      {
                        EN: `Additional Address #${i+1} (English)`,
                        TC: `附加地址 #${i+1} (英文)`
                      }, {width: "50%", starred: false})}
                    {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                      {
                        EN: "(Chinese)",
                        TC: "(中文)"
                      }, {width: "44%", starred: false})}
                    <XButton color={ColorX.CSS("Blood")} 
                      onPress={() => this._removeRow("meta.additionalAddress", i)}>
                      <MdClose/>
                    </XButton>
                  </HStack>
                );
              })}
            </VStack>
            <HStack HAlign="[">
              <XButton color={ColorX.CSS("Axit")} 
                onPress={() => this._addRow("meta.additionalAddress")}>
                <HStack>
                  <XText bold>
                    {LocaleX.Parse({
                      EN: "+ Add more address",
                      TC: "+ 增加更多地址"
                    })}
                  </XText>
                </HStack>
              </XButton>
            </HStack>
          </QForm>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._close, this._onSubmit, 
          {
            nextCap: {
              EN: "Submit",
              TC: "提交"
            },
            validateNext: this._validateCI
          }, loading)}
      </VStack>
    );
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Client Added Successfully",
                TC: "已成功新增客戶"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will be shown on the Client Management page",
                TC: "將會顯示在客戶管理頁面"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtnInverse} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderMain(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderCustomerInfo();
      case 1: return this.renderSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={705} maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        <VStack fullWidth>
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

}

export default observer(NewClientW);
